import { Loader2 } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { Button } from '../ui/button';

interface WarningDialogProps {
  buttonText?: string;
  onConfirm: () => void;
  loading?: boolean;
  title?: string;
  description?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const WarningDialog = ({
  onConfirm,
  buttonText,
  loading,
  title,
  description,
  open,
  onOpenChange,
}: WarningDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] bg-white dark:bg-foreground dark:text-white">
        <DialogHeader>
          <DialogTitle>{title ?? 'Delete'}</DialogTitle>
        </DialogHeader>
        {description && (
          <p>{description ?? 'Are you sure you want to delete?'}</p>
        )}
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            type="button"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{' '}
            {buttonText ?? 'Confirm'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WarningDialog;
